<div class="padding flex column fix-width">
  <h4 class="bold margin-bottom-small">Edit format {{ data.format.code }}</h4>
  <span class="grey small margin-bottom">{{ data.format.description }}</span>

  <div class="flex column">
    <div class="flex center">
      <b>Size (px)</b>
      @if (validation.size) {
        <span class="red margin-left">{{ validation.size }}</span>
      }
    </div>
    <input
      type="number"
      class="margin-top-smallest full-width padding-small border"
      [min]="minSize"
      [max]="maxSize"
      [(ngModel)]="size"
      (ngModelChange)="onSizeChange()"
    />
    <span class="grey small margin-top-smallest">
      Square image: {{ size ?? '-' }} × {{ size ?? '-' }} px, between {{ minSize }} and {{ maxSize }} px.
    </span>

    <b class="margin-top margin-bottom-smallest">Status</b>
    <div class="flex center">
      <div class="flex center hover" (click)="toggleActive()">
        <i
          class="primary-dark margin-right-smallest fa {{
            active ? 'fa-solid fa-check-square' : 'fa-regular fa-square'
          }}"
        ></i>
        @if (active) {
          <span class="bg-green white radius padding-left-smallest padding-right-smallest">Active</span>
        } @else {
          <span class="grey">Inactive</span>
        }
      </div>
      @if (validation.active) {
        <span class="red margin-left">{{ validation.active }}</span>
      }
    </div>
  </div>

  <div class="flex column end margin-top">
    <div class="flex center">
      <button class="stroked margin-right-small" (click)="close()">
        <i class="fa-solid fa-undo"></i>
        Discard
      </button>
      <button (click)="apply()">
        <i class="fa-solid fa-check"></i>
        Apply
      </button>
    </div>
  </div>
</div>
